import React from 'react';
import { Spin, Typography } from 'antd';

const { Text } = Typography;

interface LoadingSpinnerProps {
  size?: 'small' | 'default' | 'large';
  text?: string;
  height?: string | number;
  className?: string;
  style?: React.CSSProperties;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'large',
  text = '加载中...',
  height = '200px',
  className = '',
  style = {}
}) => {
  return (
    <div 
      className={`web-loading ${className}`}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: height,
        width: '100%',
        ...style
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <Spin size={size} />
        {text && (
          <div style={{ marginTop: 16 }}>
            <Text type="secondary">{text}</Text>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoadingSpinner;
